import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { HeroSection } from "@/components/home/HeroSection";
import { CategoryGrid } from "@/components/home/CategoryGrid";
import { ValuePropositions } from "@/components/home/ValuePropositions";
import { TrustBadgesSection } from "@/components/home/TrustBadgesSection";
import { B2BSection } from "@/components/home/B2BSection";
import { CTASection } from "@/components/home/CTASection";
import { LocationReviews } from "@/components/location/LocationReviews";
import { FAQSection } from "@/components/home/FAQSection";
import { DeliverySection } from "@/components/home/DeliverySection";
import { DeliveryCommitmentQuote } from "@/components/home/DeliveryCommitmentQuote";
import { SocialConnectSection } from "@/components/home/SocialConnectSection";
import { SEO, getOrganizationSchema, getBrandSchema, getWebsiteSchema, getFAQSchema } from "@/components/SEO";
import { homeFaqs } from "@/components/home/FAQSection";

const Index = () => {
  // Homepage advertises the national Supreme Turf entity + brand + website only.
  // Per-branch LocalBusiness entities live on /locations/:id pages (verified hours).
  const structuredData = {
    '@context': 'https://schema.org',
    '@graph': [
      getOrganizationSchema(),
      getBrandSchema(),
      getWebsiteSchema(),
      getFAQSchema(homeFaqs),
    ],
  };

  return (
    <div className="flex min-h-screen flex-col">
      <SEO
        title="Premium Building & Landscaping Materials"
        description="Supplying quality artificial grass, WPC decking, cladding & accessories to trade and homeowners across QLD, NSW, VIC & SA."
        keywords="artificial grass Australia, WPC decking, composite cladding, landscaping materials, building supplies, trade pricing"
        canonicalUrl="/"
        structuredData={structuredData}
      />
      <Header />
      <main className="flex-1">
        <HeroSection />
        <TrustBadgesSection />
        <CategoryGrid />
        <ValuePropositions />
        <LocationReviews />
        <B2BSection />
        <DeliveryCommitmentQuote />
        <DeliverySection />
        <FAQSection />
        <SocialConnectSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
